import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { FolderIcon, SharedIcon } from 'theme/icons';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { changeFolder, removeProvider, addFolder, getFolderPaths } from 'redux/modules/cloudFolders';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from 'react-router-dom';
import { CLOUD_FOLDER } from 'routes';
import { trackAddTeamFolder } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import { fetchSession } from 'redux/modules/session';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import emptyFolderImage from '../../images/empty_folder.png';
import classNames from 'classnames';
import _ from 'lodash';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const PARENT_FOLDER = 'parentFolderId';
const SHARED_FOLDER_FILEID = 'shared';
const isSharedFolder = ({fileId}) => fileId && fileId.toLowerCase() === SHARED_FOLDER_FILEID;

const styles = theme => ({
	tableCellBorder: {
		border: 'none'
	},
	button: {
		minWidth: 105,
		margin: '8px 0'
	},
	hide: {
		visibility: 'hidden'
	},
	breadcrumbRoot: {
		display: 'flex',
		marginLeft: theme.spacing.unit,
	},
	capitalize: {
		textTransform: 'capitalize'
	},
	providersSection: {
		display: 'flex'
	},
	breadcrumbContainer: {
		display: 'flex',
	},
	breadCrumbClickableItem: {
		cursor: 'pointer',
	},
	breadCrumbSeparator: {
		margin: `0 ${theme.spacing.unit / 2}px`
	},
	breadCrumbItem: {
		fontWeight: 'bold',
		color: theme.palette.colors.zeta,
	},
	emptyFolderInfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center'
	},
	folderLabel: {
		fontSize: 13,
		textDecoration: 'none'
	},
	sectionContainer: {
		marginTop: theme.spacing.unit,
		display: 'flex'
	},
	folderIcon: {
		marginRight: theme.spacing.unit,
		color: theme.palette.colors.grey,
	},
	driveAddPopover: {
		backgroundColor: '#253440',
		padding: theme.spacing.unit,
	},
	buttonRoot: {
		textDecoration: 'none'
	},
	folder: {},
	folderButton: {
		width: 350,
		display: 'flex',
		justifyContent: 'flex-start',
	},
	providerButton: {
		paddingLeft: theme.spacing.unit
	}
});
@withStyles(styles)
class CloudBrowser extends Component {
	state = {
		selectedFolder: null,
		showButton: {},
		popoverAnchorEl: undefined,
		popoverRemoveAnchorEl: undefined
	};

	handlePopoverClose() {
		this.setState({
			popoverAnchorEl: null,
			popoverRemoveAnchorEl: null
		});
	}

	cancelFolderSelection() {
		return this.setState({ cancel: true });
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (!this.state.fileId && !this.state.providerId && nextProps.selectedFolder && nextProps.folders) {
			const folder = nextProps.folders[nextProps.selectedFolder];

			if (folder) {
				this.setState({
					fileId: folder.fileId,
					providerId: folder.providerId
				});
			}
		}
	}

	changeFolder(event, fileId, providerId) {
		const { changeFolder, folders } = this.props;

		// Go to select drive state.
		if (fileId === null) {
			this.cancelFolderSelection();
			return;
		}

		// We downloaded already this folder get it from store.
		if (!folders[fileId + providerId]) {
			changeFolder(fileId, providerId, {
				fileId: this.state.fileId || null,
				providerId: this.state.providerId || providerId
			});
		}

		this.setState({
			fileId,
			providerId,
			selectedFolder: fileId + providerId
		});
	}

	addFolder(fileId, providerId) {
		const { type, companyId, addFolder } = this.props;
		const folder = {
			fileId,
			providerId,
			type,
			companyId,
			currentFolder: {
				fileId: this.state.fileId,
				providerId: this.state.providerId
			}
		};
		addFolder(folder)
			.then(response => {
				if (response && response.result && response.result.ok) {
					trackAddTeamFolder(
						_.pick(folder, ['fileId', 'type', 'providerId', 'companyId']),
						getTrackingOptions(this.props.company)
					);
					this.cancelFolderSelection();
					return fetchSession();
				}
			});
	}

	/**
	 * Render folder button.
	 *
	 * content.fileId === null means that we are on top level then render empty element.
	 *
	 * @param {Object} content
	 * @param {number} index
	 * @returns {*}
	 */
	renderFolderButton(content, index) {
		const { classes } = this.props;

		if (content.fileId === null) {
			return (<div></div>);
		} else if (content.goBack) {
			return;
		}

		return (isSharedFolder(content)
			? <Button
				data-tid={`button-cloud-browser-shared-folder-${index}`}
				className={classes.folderButton}
				classes={{
					root: classes.buttonRoot
				}}
				onClick={event => this.changeFolder(event, content.fileId, content.providerId)}>
				<SharedIcon className={classes.folderIcon} />
				<Typography className={classes.folderLabel}>{localize('cloud-browser-shared')}</Typography>
			</Button>
			: <Button
				data-tid={`button-cloud-browser-folder-${index}`}
				className={classes.folderButton}
				classes={{
					root: classes.buttonRoot
				}}
				onClick={event => this.changeFolder(event, content.fileId, content.providerId)}>
				<FolderIcon className={classes.folderIcon}/>
				<Typography className={classes.folderLabel}>{content.title}</Typography>
			</Button>);
	}

	/**
	 * Creates redirect url.
	 *
	 * If {props.match.tab} is set url will redirect to Documents|Asset tab.
	 * If {props.match.asset} is set url will redirect to Logo|Image|Other section.
	 *
	 * @returns {string}
	 */
	createRedirectUrl() {
		const { companyId, match } = this.props;

		let path = CLOUD_FOLDER.replace(':companyId', companyId);

		if (match.params.tab) {
			path += `/${match.params.tab}`;

			if (match.params.asset) {
				path += `/${match.params.asset}`;
			}
		}

		return path;
	}

	renderEmptyFolderInfo() {
		const { classes: { emptyFolderInfo } } = this.props;

		return (<div className={emptyFolderInfo}>
			<div><img src={emptyFolderImage}/></div>
			<Typography>{localize('cloud-browser-no-subfolders')}</Typography>
			<Typography>{localize('cloud-browser-go-back')}</Typography>
		</div>);
	}

	changePath(providerId, path) {
		const { folders } = this.props;
		const folder = folders[path + providerId];

		this.changeFolder(null, folder.fileId, folder.providerId);
	}

	renderBreadCrumbs(content, providerId, fileId) {
		if (!content.goBack) {
			return;
		}

		const {
			parents,
			folders,
			classes: {
				breadcrumbRoot,
				breadcrumbContainer,
				breadCrumbItem,
				breadCrumbClickableItem,
				breadCrumbSeparator,
				capitalize }
		} = this.props;
		const breadcrumbs = getFolderPaths({ parents, folders }, { providerId, fileId })
			.reverse();

		return (<div className={breadcrumbRoot}>
			{breadcrumbs.map((breadcrumb, index) => (<div key={breadcrumb.id}>
				<div className={breadcrumbContainer}>
					<Typography
						className={classNames(breadCrumbItem, breadCrumbClickableItem, index === 0 && capitalize)}
						onClick={() => this.changePath(providerId, breadcrumb.id)}>{breadcrumb.displayName}
					</Typography>
					<Typography className={classNames(breadCrumbSeparator, breadCrumbItem)}>
						{index < (breadcrumbs.length - 1) ? '>' : ''}
					</Typography>
				</div>
			</div>))}
		</div>);
	}

	renderFolderButtons(content, providerId) {
		const { classes } = this.props;

		if (isSharedFolder(content)) {
			return (<Button
				variant='contained'
				data-tid={`button-cloud-browser-open-${content.fileId}`}
				color='primary'
				className={classes.button}
				onClick={event => this.changeFolder(event, content.fileId, content.providerId)}>
				{localize('cloud-browser-open-button')}
			</Button>);
		} else if (content.filename !== PARENT_FOLDER) {
			return (<Button
				variant='contained'
				data-tid={`button-cloud-browser-${content.fileId}`}
				color='primary'
				className={classes.button}
				onClick={() => this.addFolder(content.fileId, providerId)}>{localize('cloud-browser-add-button')}</Button>);
		} else if (content.goBack) {
			return (<Button
				variant='contained'
				data-tid="button-cloud-browser-cancel"
				className={classes.button}
				onClick={this.cancelFolderSelection.bind(this)}>{localize('cancel')}</Button>);}
	}

	renderFolders({ contents, providerId, fileId }) {
		const { classes, parents } = this.props;
		const parent = parents[fileId + providerId];
		const hasContent = contents.length > 0;

		contents = [
			{
				filename: PARENT_FOLDER,
				fileId: parent.fileId,
				providerId: parent.providerId,
				goBack: true
			},
			...contents
		];

		return (
			<Table className={classes.table}>
				<TableBody>
					{
						contents.map((content, index) => {
							return (
								<TableRow key={content.fileId || 'root'} hover={!content.goBack}>
									<TableCell
										padding='none'
										classes={{
											root: hasContent ? null : classes.tableCellBorder
										}}>
										{this.renderBreadCrumbs(content, providerId, fileId)}
										{this.renderFolderButton(content, index)}
									</TableCell>
									<TableCell
										padding='none'
										align='right'
										className={classNames(content.goBack && !hasContent && classes.hide)}>
										{this.renderFolderButtons(content, providerId)}
									</TableCell>
								</TableRow>);
						})
					}
				</TableBody>
			</Table>
		);
	}

	render() {
		const { cloudProviders, loading, folders } = this.props;
		let { selectedFolder, cancel } = this.state;

		if (cancel) {
			return (<Redirect to={this.createRedirectUrl()}/>);
		}

		if (!selectedFolder) {
			selectedFolder = this.props.selectedFolder;
		}

		const isLoading = loading && selectedFolder && !folders[selectedFolder];
		const currentFolderData = selectedFolder && folders[selectedFolder];
		const hasContent = currentFolderData && currentFolderData.contents.length > 0;

		const addRemoveButton = cloudProviders.length > 0;
		const cloudStores = [...cloudProviders, {
			providerName: 'add',
			providerId: 'add-new'
		}];

		if (addRemoveButton) {
			cloudStores.push({
				providerName: 'remove',
				providerId: 'remove'
			});
		}

		return (<div>
			<div>
				{currentFolderData && this.renderFolders(currentFolderData)}
				{!hasContent && !loading && this.renderEmptyFolderInfo()}
			</div>
			{isLoading && <CircularProgress/>}
		</div>);
	}

}

const mapStateToProps = state => ({
	cloudProviders: state.cloudFolders.cloudProviders,
	loading: state.cloudFolders.loading,
	folders: state.cloudFolders.folders,
	parents: state.cloudFolders.parents,
	companyId: state.companies.selectedId,
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	fetchSession,
	addFolder,
	changeFolder,
	removeProvider,
}, dispatch);

CloudBrowser.propTypes = {
	fetchSession: PropTypes.func,
	addFolder: PropTypes.func,
	type: PropTypes.string.isRequired,
	selectedFolder: PropTypes.string,
	loading: PropTypes.bool,
	changeFolder: PropTypes.func.isRequired,
	removeProvider: PropTypes.func.isRequired,
	classes: PropTypes.object,
	parents: PropTypes.object,
	cloudProviders: PropTypes.array,
	folders: PropTypes.object,
	companyId: PropTypes.string,
	company: PropTypes.object,
	match: PropTypes.object.isRequired
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CloudBrowser);



// WEBPACK FOOTER //
// ./src/components/CloudBrowser/CloudBrowser.js